import { OrganizationalUnitsRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: OrganizationalUnitsRepository,
): Interactor {
  return ({ organizationalUnit, name }) =>
    present(
      repository
        .editOrganizationalUnit(organizationalUnit, name)
        .then((editedOrganizationalUnit) => ({
          organizationalUnit: editedOrganizationalUnit,
        }))
        .catch(() => Promise.reject({ organizationalUnit })),
    );
}

export type { Interactor };

export { createInteractor };
